import { locationDTOSchema, locationKioskBrandingViewDTOSchema, locationKioskSettingViewDTOSchema, locationTreeDTOSchema, locationAppSubscriptionSummaryDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, listEnvelopeSchema, WEB_API_PREFIX, } from '../transport.js';
const listLocationsSchema = listEnvelopeSchema(locationDTOSchema);
const locationTreeSchema = dataEnvelopeSchema(locationTreeDTOSchema);
const appSubscriptionsSchema = dataEnvelopeSchema(z.array(locationAppSubscriptionSummaryDTOSchema));
const singleLocationSchema = dataEnvelopeSchema(locationDTOSchema);
const singleBrandingSchema = dataEnvelopeSchema(locationKioskBrandingViewDTOSchema);
const singleKioskSettingSchema = dataEnvelopeSchema(locationKioskSettingViewDTOSchema);
export function createLocationsResource(transport) {
    return {
        async list(params = {}) {
            return transport.request({
                path: `${WEB_API_PREFIX}/locations`,
                schema: listLocationsSchema,
                query: { page: params.page, pageSize: params.pageSize, sort: params.sort },
            });
        },
        async tree() {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/locations/tree`,
                schema: locationTreeSchema,
            });
            return envelope.data;
        },
        async create(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/locations`,
                schema: singleLocationSchema,
                body: input,
            });
            return envelope.data;
        },
        async update(id, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(id)}`,
                schema: singleLocationSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(id) {
            await transport.request({
                method: 'DELETE',
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(id)}`,
                schema: z.undefined(),
            });
        },
        async appSubscriptions() {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/locations/app-subscriptions`,
                schema: appSubscriptionsSchema,
            });
            return envelope.data;
        },
        async getBranding(locationId) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/branding`,
                schema: singleBrandingSchema,
            });
            return envelope.data;
        },
        async setBranding(locationId, input) {
            const envelope = await transport.request({
                method: 'PUT',
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/branding`,
                schema: singleBrandingSchema,
                body: input,
            });
            return envelope.data;
        },
        async uploadLogo(locationId, file, contentType) {
            const envelope = await transport.requestUpload({
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/branding/logo`,
                schema: singleBrandingSchema,
                contentType,
                body: file,
            });
            return envelope.data;
        },
        async removeLogo(locationId) {
            await transport.request({
                method: 'DELETE',
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/branding/logo`,
                schema: z.undefined(),
            });
        },
        async getLogo(locationId) {
            return transport.requestBlob({
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/branding/logo`,
                // `image/*` rather than the three members of KIOSK_LOGO_CONTENT_TYPES: the route
                // ignores `accept` entirely and answers with the stored row's own content type, so
                // naming them here would be a second list to keep in step for no behavioural gain.
                accept: 'image/*',
            });
        },
        async getKioskSettings(locationId) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/kiosk-settings`,
                schema: singleKioskSettingSchema,
            });
            return envelope.data;
        },
        async updateKioskSettings(locationId, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/kiosk-settings`,
                schema: singleKioskSettingSchema,
                body: input,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=locations.js.map